import React from "react";
import { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebase Component/firebase-config";
function MsgBox(props) {
  return (
    <div>
      <h1 className="title-font sm:text-3xl text-2xl mb-4 font-poppinsBold text-cusOrange  ali">
        {props.name}
      </h1>

      <h1 className="title-font sm:text-4xl text-3xl mb-4 font-poppinsBold text-cusOrange  ali">
        {props.title}
      </h1>

      <div className="invisible"></div>
      <h1 className="title-font sm:text-xl text-lg m-24 font-poppinsLight text-gray-900 ali">
        {props.message}
      </h1>
    </div>
  );
}

const MsgRendering = ({ message, title, name, date, Id, read, collection }) => {


  return (
    <div className="text-center lg:w-2/3 w-auto h-full">
      <MsgBox message={message} title={title} name={name} />
      <div>
        
        <h2 className="title-font sm:text-2xl text-1xl mb-4 font-poppinsBold text-cusOrange font-light">
          {date}
        </h2>
      </div>
      <div class="p-2 w-full pt-8 mt-8 border-t border-cusOrange text-center"></div>
    </div>
  );
};
function sort_by_number() {
  return function (elem1, elem2) {
    if (elem1.number < elem2.number) {
      return -1;
    } else if (elem1.number > elem2.number) {
      return 1;
    } else {
      return 0;
    }
  };
}

function OldMsg() {
  const CollectionName = "Msg";
  const [Data, setData] = useState([]);
  const dataRef = collection(db, String(CollectionName));

  const DataFetching = async () => {
    const data = await getDocs(dataRef);
    
     const ArrData = data.docs.map((recData) => ({ ...recData.data(), id: recData.id }))
    const Arr = ArrData.filter((num)=> num.read === true)
     Arr.sort(sort_by_number())
     setData(Arr)
    
  };

  // eslint-disable-next-line
  useEffect(() => {
    DataFetching();

    // eslint-disable-next-line
  }, []);





  

  return (
    <div className="container  mx-auto flex px-0 py-0 pt-3 items-center  justify-center flex-col">
      {Data &&
        Data.map((data, index) => {
          return (
            <MsgRendering
              message={data.msg}
              title={data.title}
              key={index}
              name={data.name}
              Id={data.id}
              date={data.date}
              read={data.read}
              collection={CollectionName}
            />
          );
        })}

    </div>
  );
}

export default OldMsg;
